import { Video } from 'api';

export enum SailthruSections {
  Recommendations = 'Recommendations',
  RecommendationsAI = 'RecommendationsAI',
  RecommendationsPsychology = 'RecommendationsPsychology',
  RecommendationsTEDEd = 'RecommendationsTEDEd',
  RecommendationsPopular = 'RecommendationsPopular',
  RecommendationsCountdown = 'RecommendationsCountdown',
  RecommendationsPodcast = 'RecommendationsPodcast',
  RecommendationsTrending = 'RecommendationsTrending',
  RecommendationsNewest = 'RecommendationsNewest'
}

export const sections = {
  [SailthruSections.Recommendations]: '9b4e837a-8318-11ee-911b-6a096f159873',
  [SailthruSections.RecommendationsAI]: '15375c30-b1bb-11ef-95a6-a2beda6870dc',
  [SailthruSections.RecommendationsPsychology]:
    '3a78a186-30b3-11ef-9854-9e7797660639',
  [SailthruSections.RecommendationsTEDEd]:
    '8fe0ecb2-b1bb-11ef-9465-42b3bfa427b2',
  [SailthruSections.RecommendationsPopular]:
    '932421fe-b1b2-11ef-8365-5a69f29232d2',
  [SailthruSections.RecommendationsCountdown]:
    'b3c7842e-b1bb-11ef-8365-5a69f29232d2',
  [SailthruSections.RecommendationsPodcast]:
    'ebc3e198-502b-11ef-a405-0273a0c42201',
  [SailthruSections.RecommendationsTrending]:
    'e499d75a-b1bb-11ef-95a6-a2beda6870dc',
  [SailthruSections.RecommendationsNewest]:
    '4b17e0d0-d3ef-11ef-af35-eacb2f1c3c9a'
};

type RecommendationVideo = Partial<Video> & {
  title: string;
  url: string;
  description: string;
  id: string;
};

export type Recommendation = {
  video: RecommendationVideo;
};

export type SailthruItem = {
  url: string;
  title: string;
  description: string;
  views: number;
  date: string;
  tags: string[];
  image: string;
  vars: {
    duration: number;
    presenter_display_name: string;
    filmed_date: string;
    social_description: string;
    talk_type: string;
    talk_context: string;
    curator_approved: boolean;
  };
};

export type SailthruFormattedItem = {
  id: string;
  title: string;
  description: string;
  canonicalUrl: string;
  duration: number;
  publishedAt: number;
  presenterDisplayName: string;
  viewedCount: number;
  topics: {
    nodes: {
      name: string;
    }[];
  };
  primaryImageSet: [
    {
      url: string;
      aspectRatioName: string;
    }
  ];
  slug: string;
  type: {
    name: string;
  };
};

export type SailthruDataContentTypeSpecific = {
  [key in SailthruSections]: {
    id: string;
    title: string;
    description: string;
  }[];
};

export type SailthruDataContentType = {
  [key in SailthruSections]: SailthruFormattedItem[];
};
